import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  staffDetail: null,
  staffLoading: false,
  staffAttendance: [],
  staffAttendanceLoading: false
};

const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    _setStaffDetail: (state, action) => {
      state.staffDetail = action.payload;
    },
    _setStaffLoading: (state, action) => {
      state.staffLoading = action.payload;
    },
    _setStaffAttendance: (state, action) => {
      state.staffAttendance = action.payload || [];
    },
    _setStaffAttendanceLoading: (state, action) => {
      state.staffAttendanceLoading = action.payload || false;
    }
  },
});

export const {
  _setStaffDetail,
  _setStaffLoading,
  _setStaffAttendance,
  _setStaffAttendanceLoading
} = staffSlice.actions;

export default staffSlice.reducer;
